<template>
    <div class="row">
        <div class="col-6" align="left">
            <div class="row">
                <div class="col-8">Zurzeit erzeugt:</div>
                <div class="col-4">{{ energy.current }} W</div>
                <div class="col-8">Heute erzeugt:</div>
                <div class="col-4">{{ energy.today }} kWh</div>
                <div class="col-8">Gesamt erzeugt:</div>
                <div class="col-4">{{ energy.total }} MWh</div>
            </div>
        </div>
        <div class="col-6" align="left">
            <div class="row">
                <div class="col-8">CO2 Ersparnisse:</div>
                <div class="col-4">{{ co2.total }} kg</div>
                <div class="col-8">Verdienst Heute:</div>
                <div class="col-4">{{ money.today }} €</div>
                <div class="col-8">Verdienst gesamt:</div>
                <div class="col-4">{{ money.total }} €</div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '../../services/VuexStore';

    export default {
        name: 'PvInformation',
        components: {},
        props: {},
        data () {
            return {
                energy: {
                    current: 0,
                    today: 0,
                    total: 0,
                },
                money: {
                    today: 0,
                    total: 0,
                },
                co2: {
                    total: 0,
                },
            };
        },
        methods: {
            refreshData: function () {
                this.money = store.state.money || {};
                this.energy = store.state.energy || {};
                this.co2 = store.state.co2 || {};
            },
        },
        mounted () {
            this.refreshData();
            setInterval(this.refreshData, 2000);
        },
    };
</script>

<style scoped>

</style>
